import React, { ReactNode } from 'react';

const IsiContainer: React.FC<{ children: ReactNode }> = ({children}) => {
	return (
        <div className="bg-white shadow-leap">
            {children}
        </div>
	);
};

export default IsiContainer;